import { isIOS, isAndroid } from "components/MapGrid/utils";

export const APP_USAGE_EVENT_TYPE = {
    SESSION_EVENT: "SESSION_EVENT",
    USER_ACTION: "USER_ACTION",
};

export const APP_USAGE_EVENT = {
    APP_OPEN: "APP_OPEN",
    SIGN_UP: "SIGN_UP",
    SIGN_IN: "SIGN_IN",
    ANONYMOUS_ACCESS: "ANONYMOUS_ACCESS",
    ADD_ROOM: "ADD_ROOM",
    SCREEN_VIEW: "SCREEN_VIEW",
};

export const APP_USAGE_FORM_FACTOR = {
    PHONE: "PHONE",
    TABLET: "TABLET",
    DESKTOP: "DESKTOP",
};

export const APP_USAGE_OS = {
    ANDROID: "ANDROID",
    IOS: "IOS",
};

export const detectFormFactor = () => {
    if (typeof navigator === "undefined" || typeof window === "undefined") {
        return APP_USAGE_FORM_FACTOR.DESKTOP;
    }

    const ua = navigator.userAgent || navigator.vendor || window.opera;

    if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) {
        return APP_USAGE_FORM_FACTOR.TABLET;
    }

    if (/iPhone|iPod|Android.+Mobile/i.test(ua)) {
        return APP_USAGE_FORM_FACTOR.PHONE;
    }

    if (/iPad|Tablet|Android(?!.*Mobile)/i.test(ua)) {
        return APP_USAGE_FORM_FACTOR.TABLET;
    }

    if (window.innerWidth < 768) {
        return APP_USAGE_FORM_FACTOR.PHONE;
    }

    if (window.innerWidth <= 1024) {
        return APP_USAGE_FORM_FACTOR.TABLET;
    }

    return APP_USAGE_FORM_FACTOR.DESKTOP;
};

export const detectOperatingSystem = () => {
    try {
        if (typeof navigator === "undefined") return undefined;
        if (isIOS()) return APP_USAGE_OS.IOS;
        if (isAndroid()) return APP_USAGE_OS.ANDROID;
        return undefined;
    } catch {
        return undefined;
    }
};
